<template>
    <div>
    <b-modal v-model="isOpen" 
    centered
    size='lg' 
    :ok-title='txtAccept' 
    :cancel-title='txtCancel' 
    :ok-only='onlyOk'
    @ok='onAccept'
    @cancel='onDecline'
    @hidden ='onDecline'
    :title ='title'
    >
      <div v-html="message"></div>
    </b-modal>
    </div>
</template>
<script>

import {bus} from '@/main'
export default {
    name: 'modalInfo',
  data () {
    return {
      message: 'Mensaje modal',
      txtAccept: 'Aceptar',
      txtCancel: 'Cancelar',
      title: 'Mensaje informativo',
      isOpen: false,
      canceled: this.isclose,
      accepted: this.isclose,
      open: false,
      onlyOk: true
    }
  },
  watch: {
    open: function (newVal) {
      this.isOpen = newVal
      this.setUpModal()
    }
  },
  mounted () {
    this.open = false
    this.canceled = this.isclose
  },
  created () {
    bus.$on('showDialog', (data) => {
      this.title = data.title
      this.txtCancel = data.cancel
      this.txtAccept = data.accept
      this.message = data.body
      this.onlyOk = data.cancel ? false : true
      this.canceled = data.onCancel ? data.onCancel : this.closeModal
      this.accepted = data.onAccept ? data.onAccept : this.closeModal
      this.open = true
    });
    bus.$on('closeDialog', ()=>{
      this.open = false;
    });
  },
  methods: {
    setUpModal () {
      if (this.txtCancel && !this.txtCancel.length && !this.cancel) {
        this.canceled = this.closeModal
      }
      if (!this.onAccept) {
        this.onAccept = this.closeModal
      }
    },
    onAccept () {
      this.closeModal()
      this.accepted()
    },
    onDecline (myfunction) {
      this.closeModal()
      this.canceled()
    },
    closeModal () {
      this.open = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/base/modalInfo.vue